import { render, staticRenderFns } from "./JCCapital.vue?vue&type=template&id=f2175708&scoped=true&"
import script from "./JCCapital.vue?vue&type=script&lang=js&"
export * from "./JCCapital.vue?vue&type=script&lang=js&"
import style0 from "./JCCapital.vue?vue&type=style&index=0&id=f2175708&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2175708",
  null
  
)

export default component.exports